// extracted by mini-css-extract-plugin
export default {"root":"_1scbddSt","content":"BNwd9llS","line":"_1uW7hZKH","quote":"_1yEGYDCs","author":"_2PtxkfqC"};